import { Oauth2Client } from "@/services/oauth2-client"
import { useEffect, useState } from "react"

export function CallbackPage() {
    const [user, setUser] = useState("")
    useEffect(()=>{
        callback()
    },[])

    async function callback(){
        await Oauth2Client.callback()
        const user = await Oauth2Client.getUser()
        setUser(user.access_token)
        
    }
    return (
        <p>{user}</p>
    )
}